export default __webpack_public_path__ + "static/media/royal-orchid.32b5994c.svg";